/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OtResponse } from '../../models/ot-response';

export interface GetOtsToDoForEquipement$Params {
  /**
   * idEquipement
   */
  idEquipement: string;
}

export function getOtsToDoForEquipement(
  http: HttpClient,
  rootUrl: string,
  params: GetOtsToDoForEquipement$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<OtResponse>>> {
  const rb = new RequestBuilder(rootUrl, getOtsToDoForEquipement.PATH, 'get');
  if (params) {
    rb.query('idEquipement', params.idEquipement, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OtResponse>>;
    })
  );
}

getOtsToDoForEquipement.PATH = '/v2/ots/ots_to_do_for_equipement';
